import { render, staticRenderFns } from "./TuSeguroEmisiones.vue?vue&type=template&id=4be23404"
import script from "./TuSeguroEmisiones.vue?vue&type=script&lang=js"
export * from "./TuSeguroEmisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports